<template>
  <div v-if="selectedPlan !== null && selectedPlan !== undefined">
    <v-container>
      <v-row justify="center">
        <v-dialog scrollable v-model="getReportDialog" persistent max-width="1200">
          <material-card title="Demographics Report" icon="pie_chart" :color="$vuetify.theme.themes.light.secondary">
            <v-card-text v-if="reportUrl">
              <demographics-table
                ref="reportTable"
                :url="reportUrl"
                @onerror="onTableError($event)"
                :inArchive="true"
                :insuranceCarrier="insuranceCarrier"
                :date="date"
                :identifier="selectedPlan.Id + '_demographicsReportTable'"
              ></demographics-table>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" @click="closeReportDialog()">
                {{
                $t("globals.close")
                }}
              </v-btn>
            </v-card-actions>
          </material-card>
        </v-dialog>
      </v-row>
    </v-container>
    <material-card :title="$t('views.demographicsarchive.demographics_archive')" :color="$vuetify.theme.themes.light.secondary" icon="pie_chart">
      <pbas-data-table
        :exporters="$exporters"
        ref="table"
        :dataProvider="provider"
        fileNamePrefix="demographics-archive"
        :sortBy="'Date'"
        :sortDescending="true"
        :rowActions="rowActions"
        identifier="demographicsTable"
        @error="error=$event"
      ></pbas-data-table>
      <error-handler :error="error"></error-handler>
    </material-card>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="accent"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import DemographicsArchiveHeaders from "../headers/DemographicsArchive";
import DemographicsTable from "../components/DemographicsTable";
import ErrorHandler from "../components/ErrorHandler";
import { planSetter } from "../mixins/planSetter";

export default {
  name: "demographics-archive",
  components: {
    DemographicsTable,
    ErrorHandler
  },
  mixins: [planSetter],
  data() {
    return {
      error: null,
      date: null,
      insuranceCarrier: null,
      provider: undefined,
      reportUrl: null,
      getReportDialog: false,
      rowActions: [
        {
          name: "getReport",
          icon: "file_copy",
          title: "Get Report",
          handler: item => {
            //console.log(item.Id)
            this.insuranceCarrier = item.PlanInsuranceCarrier;
            this.date = item.Date;
            this.reportUrl =
              "plans/" +
              this.selectedPlan.Id +
              "/demographics/archive/" +
              item.Id;
            this.getReportDialog = true;
            //if (this.$refs.reportTable) this.$refs.reportTable.getDataAsync();
          }
        }
      ],
      headers: DemographicsArchiveHeaders
    };
  },
  computed: {
    ...mapGetters("common", ["messages"]),
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("auth", ["isLoggedIn", "user", "role"]),
    ...mapGetters("common", ["settings"])
  },
  watch: {
    selectedPlan: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  mounted() {
    if (this.selectedPlan !== null && this.selectedPlan !== undefined) {
      this.loadPlanData();
    }
  },
  methods: {
    /*$t(args) {
        console.log(this.messages, args)
        if (Object.keys(this.messages).indexOf(args) < 0) {
            this.messages[args]="TRANSLATION REQUIRED"
        }
        return "TRANSLATION REQUIRED";
    },*/
    closeReportDialog() {
      this.$refs.reportTable.provider=undefined;
      this.reportUrl = null
      this.getReportDialog = false
    },
    onTableError(error) {
      this.error = error;
    },
    async loadPlanData() {
      let url = "plans/" + this.selectedPlan.Id + "/demographics/archive";

      this.provider = new PbasOData(
          this.$axiosHttp,
          url,
          this.headers
        );
    }
  }
};
</script>
